import React, { useState, useEffect, useRef } from 'react';
import './task3.css';
import Settings from '../components/common/settings';
import { useNavigate } from 'react-router-dom';

import settingsSound from '../audios/settoings.wav';
import Lost from '../components/common/lost';

const TOTAL_TIME = 10 * 60;

const getInitialTime = () => {
  const saved = localStorage.getItem('room1_time');

  if (!saved) {
    localStorage.setItem('room1_time', Date.now());
    return TOTAL_TIME;
  }

  const elapsed = Math.floor((Date.now() - Number(saved)) / 1000);
  return Math.max(TOTAL_TIME - elapsed, 0);
};

const CLUE_TEXT = "Clue: Find the key out";

const Task3 = () => {
  const navigate = useNavigate();

  const [timeLeft, setTimeLeft] = useState(getInitialTime());
  const [openSettings, setOpenSettings] = useState(false);
  const [showClue, setShowClue] = useState(false);
  const [showLosePopup, setShowLosePopup] = useState(false);

  const settingsAudio = useRef(null);

  useEffect(() => {
    settingsAudio.current = new Audio(settingsSound);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(() => {
        const saved = localStorage.getItem('room1_time');
        if (!saved) return TOTAL_TIME;

        const elapsed = Math.floor((Date.now() - Number(saved)) / 1000);
        const remaining = Math.max(TOTAL_TIME - elapsed, 0);

        if (remaining === 0) {
          setShowLosePopup(true);
          clearInterval(interval);
        }

        return remaining;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const playSettingsSound = () => {
    if (!settingsAudio.current) return;
    settingsAudio.current.currentTime = 0;
    settingsAudio.current.play().catch(() => {});
  };

  const openSettingsMenu = () => {
    playSettingsSound();
    setOpenSettings(true);
  };

  const closeSettingsMenu = () => {
    playSettingsSound();
    setOpenSettings(false);
  };

  const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
  const seconds = String(timeLeft % 60).padStart(2, '0');
  const isWarning = timeLeft <= 60;
  const fillPercent = (timeLeft / TOTAL_TIME) * 100;

  return (
    <section className="room1div">

      {showClue && (
        <div className="topclue" onClick={() => setShowClue(false)}>
          {CLUE_TEXT}
        </div>
      )}

      <div className="room1nav">

        <div className="cluee" onClick={() => setShowClue(true)}>
          <div className="cluediv">
            <div className='clueicon'></div>
          </div>
          <h4 className="cluetext">CLUE</h4>
        </div>

        <div className="roomtimer">
          <span className="timerlabel">TIME REMAINING</span>

          <div className="timerdiv">
            <span className={`timerdigits ${isWarning ? 'timerwarning' : ''}`}>
              {minutes}:{seconds}
            </span>
          </div>

          <div className="timerbar">
            <div
              className="timerbartill"
              style={{
                width: `${fillPercent}%`,
                background: isWarning ? '#ff4444' : '#D4AF37',
              }}
            />
          </div>
        </div>

        <div className="settings" onClick={openSettingsMenu} />
      </div>

   
      <Settings
        open={openSettings}
        onClose={closeSettingsMenu}
        onPlaySound={playSettingsSound}
        onNavigate={navigate}
      />

      <div className="key" onClick={() => navigate('/escapedpage')} />

      <Lost
        open={showLosePopup}
        onRetry={() => {
          localStorage.removeItem('room1_time');
          window.location.reload();
        }}
      />

    </section>
  );
};

export default Task3;